import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import CompleteVersionNote from './CompleteVersionNote';
import _ from 'lodash';
import InputBox from './InputBox';
import MaterialUIMultiLine from './MaterialUIMultiLine';
import '../css/AddInternalVersion.css';
import ErrorText from '../ErrorText';
import Dropzone from './Dropzone'
import FileUpload from './drag/FileUpload'
import DragDrop from './drag/DragDrop';
import DragDropClick from './drag/DragDropClick';
// import createHistory from 'history/createBrowserHistory';
import SnackBar from './SnackBar'

// import MultiInputBox from './MultiInputBox';

// add internal version component.

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EEF3F7',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",

  },
};

const customStylesSuccess = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EEF3F7',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

export default class AddInternalVersion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.activeModal,
      modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
      modalIsOpenCompleteVersion: false,
      modalIsOpenSuccess: false,
      selectedVersion: '',
      versionType: [
        { name: 'Design Studio' },
        { name: 'HA Automation' },
        { name: 'Media' },
        { name: 'Operating System' },
        { name: 'Cloud Studio' },
        { name: 'iPad App' },
        { name: 'WE.OKAS' },
      ],
      versionUpdate: [],
      versionDataForCompleteVersion: [],
      presentVersion: [],
      fileUploadVersion: [],
      showError: false,
      files: [],
      snackbarActive: false,
      snackbarMessage: ''
      
    }

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);

  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }
  // closeModalSuccess() {
  //   this.setState({
  //     modalIsOpenSuccess: false
  //   });
  // }




  closeModalSuccess() {
    this.setState({
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpenSuccess: false
        }, () => {
          this.props.refreshVersion();
        })
      }, 500);
    })
  }
  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({
      modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpen: false
        }, () => {
          this.props.refreshVersion();
        })
      }, 500);
    })
  }

  updatePersentVersion = () => {
    let presentVersion = [];
    this.state.versionType.forEach((firstElement) => {
      let versionRawData = {};
      this.props.versionData.forEach((secondElement) => {
        if (secondElement.application_name === firstElement.name) {
          versionRawData = {
            name: firstElement.name,
            version: secondElement.Application_Version
          }
        }
      })
      presentVersion.push(versionRawData)
    })
    this.setState({
      presentVersion
    })
  }



  //handleInputChange valueName is the property name of the function and value is the property value
  // example is valueName= Media, value is release notes of media.
  //after that it clean the extra version state. 
  handleInputChange = (valueName, value) => {
    this.setState({
      fileUploadVersion: {
        ...this.state.fileUploadVersion,
        [valueName]: {
          data: this.state.fileUploadVersion[valueName] !== undefined ? this.state.fileUploadVersion[valueName].data : '',
          fileName: this.state.fileUploadVersion[valueName] !== undefined ? this.state.fileUploadVersion[valueName].fileName : '',
        }
      },
      versionUpdate: {
        ...this.state.versionUpdate,
        [valueName]: value.substring(0,500),
      },
    }, () => {
      this.cleanVersionState();
      this.forceUpdate()
      this.renderVersionSection()
    })
  }


  //this function clean the state value of version if the release note and fileupload state is not available for that section.
  cleanVersionState = () => {
    let versionUpdate = this.state.versionUpdate;
    let versionFileUpdate = this.state.fileUploadVersion;
    Object.keys(versionFileUpdate).forEach((e) => {
      if (versionFileUpdate[e].data === '' && versionUpdate[e] === '') {
        delete versionFileUpdate[e];
        delete versionUpdate[e]
      }
    });

    this.setState({
      fileUploadVersion: versionFileUpdate,
      versionUpdate,
      showError: false
    })
  }


  handleSubmit = (das) => {
    console.log('nothing to send')
  }

  //this function triggers when we click the update botton on the page,
  //it will check for errors in the field and if no error detect then it will call updateversion function  
  updateVersionIntial = (e) => {
    let fileUploadKey = Object.keys(this.state.fileUploadVersion);
    let errorInVersion = false;
    fileUploadKey.forEach((e) => {
      if (this.state.fileUploadVersion[e].data === '' || this.state.versionUpdate[e] === '') {
        errorInVersion = true;
      }
    })
    this.setState({
      showError: true
    }, () => {
      if (!errorInVersion) {
        this.updateVersion()
      }
    })
  }

  updateVersion = () => {
    let version = this.state.versionUpdate;
    let updateVersion = [];
    let completeVersion = false
    let someData = this.state.fileUploadVersion;
    Object.keys(this.state.versionUpdate).forEach(function (key, index) {
      if (key === 'Media' || key === 'Operating System' || key === 'HA Automation' || key === 'Design Studio') {
        completeVersion = true;
      }
      if (version[key].trim() !== '' && someData[key].data !== '') {
        updateVersion.push({
          application_name: key,
          release_note: version[key].trim(),
          file: someData[key].data
        })
      }
    });
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    if (updateVersion.length !== 0 && !completeVersion) {
      fetch('/cloud/versioncontrol/', {
        method: "POST",
        headers: headers,
        body: JSON.stringify(
          updateVersion
        )
      })
                 .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
        .then(data => {
          if (data.length !== 0) {
            this.setState({
              modalIsOpen: false,
              versionDataForCompleteVersion: updateVersion,
            }, () => {
              this.setState({
                modalIsOpenSuccess: true
              })
            })
            // this.props.refreshVersion();
          }
        })
        .catch((err)=>{
          console.log(err)

        })
    } else if (updateVersion.length !== 0 && completeVersion) {
      this.setState({
        modalIsOpen: false,
        versionDataForCompleteVersion: updateVersion,
      }, () => {
        this.setState({
          modalIsOpenCompleteVersion: true,
        })
      })
    } else if (updateVersion.length === 0) {
      this.setState({
        snackbarActive: true,
        snackbarMessage: 'Update any section with release notes and attachment both.'
      })
    }
  }

  componentWillMount() {
    this.renderVersionSection();
    this.updatePersentVersion();
  }

  ActivateCompleteInternalVersionModal = (e) => {
    if (this.state.modalIsOpenCompleteVersion) {
      return <CompleteVersionNote activeModal={true} versionData={this.state.versionDataForCompleteVersion} refreshVersion={this.refreshVersion.bind(this)} />
    } else {
      return null
    }
  }


  checkUpdateStatus = (name) => {
    if (this.state.versionUpdate[name] !== '') {
      return 'normal'
    } else {
      return 'bold'
    }
  }


  latestVersionName = (applicationName) => {
    var presentVersion = 'No Update Yet';
    if(this.props.versionData.length!==0){
      this.props.versionData.forEach((e)=>{
        if(e.application_name===applicationName){
          presentVersion = e.application_version
        }
      })
    }
    return presentVersion;
    }

  updateHeadingVersionSection = (sectionName) => {
    if (this.state.versionUpdate.hasOwnProperty(sectionName)) {
      if (this.state.versionUpdate[sectionName] === '') {
        return 'normal'
      } else {
        return 'bolder'
      }
    } else {
      return 'normal'
    }
  }

  handleChangeInputBox = (name, event) => {
    // this.setState({
    //   [name]: event
    // }); 
  }


  refreshVersion = () => {
    this.setState({
      modalIsOpen: false,
    }, () => {
      this.props.refreshVersion()
    })
  }
  getBase64 = (event) => {
    var input = event.target;
    var reader = new FileReader();
    if (input.files[0] !== undefined ? input.files[0].type === 'application/pdf' && input.files[0].size <= 5242880 : false) {
      reader.onload = () => {
        this.setState({
          fileUploadVersion: {
            ...this.state.fileUploadVersion,
            [this.state.selectedVersion]: {
              data: reader.result,
              fileName: input.files[0].name
            }
          },
          versionUpdate: {
            ...this.state.versionUpdate,
            [this.state.selectedVersion]: this.state.versionUpdate[this.state.selectedVersion] || ''
          }
        })
      }
    } else if (input.files[0] !== undefined ? input.files[0].type === 'application/pdf' || input.files[0].size <= 5242880 : false) {
      this.setState({
        snackbarActive: true,
        snackbarMessage: 'Upload .pdf file only and should have size of upto 5MB.'
      })
    }
    if (input.files[0] !== undefined) {
      reader.readAsDataURL(input.files[0]);
    }
  };

  renderVersionSection = () => {
    let element = this.state.versionType.map((firstElement) => {
      let name = firstElement.name;
      return (
        <React.Fragment>
          {/* <div style={{ borderBottom: '1px solid grey', }}> */}
          {/* <div style={{ borderBottom: this.state.showError ? this.findErrorInVersion(firstElement.name, 'section') ? '1px solid red' : '1px solid grey' : '1px solid grey' }} > */}
          <div style={{ borderBottom: this.state.showError ? this.findErrorInVersion(firstElement.name, 'section') ? '2px solid red' : '2px solid #E8E8EF' : '2px solid #E8E8EF' }} >
            <div className="d-flex align-items-center" style={{ height: '5vh', backgroundColor: '#EEF3F7', }}
              onClick={(e) => {
                this.setState({
                  selectedVersion: firstElement.name,
                })
              }}>
              <div className="col-12" style={{ fontWeight: this.updateHeadingVersionSection(firstElement.name) }}>
                {firstElement.name}
              </div>
            </div>
            {this.state.selectedVersion === firstElement.name ?
              <div className="col-12" style={{ backgroundColor: '#E9E9F0', borderTop: '2px solid #E9E9F0', padding: '10px 10px 30px 10px' }}>
                <div className="row p-2">
                  <div className="col-6">
                  <div style={{fontSize: '13px', fontWeight: 'bolder', marginBottom: '2px'}}>INTERFACE NAME</div>
                  <div style={{borderBottom: '#fff 2px solid', fontSize: '15px',paddingBottom: '2px' }}>{this.state.selectedVersion}</div>
                  </div> 
                  <div className="col-6">
                  <div style={{fontSize: '13px', fontWeight: 'bolder', marginBottom: '2px'}}>CURRENT VERSION</div>
                  <div style={{borderBottom: '#fff 2px solid', fontSize: '15px',paddingBottom: '2px' }}>{this.latestVersionName(firstElement.name) || ''}</div>
                  </div>                
                </div>
                <div className="col-12 p-0 mt-3">
                  <MaterialUIMultiLine
                    placeholder="Release Notes"
                    label="Release Notes"
                    rows={5}
                    handleInputChange={this.handleInputChange.bind(this)}
                    handeSubmitReply={this.handleSubmit.bind(this)}
                    name={firstElement.name}
                    inputValue={this.state.versionUpdate[name]}
                    limitLength={true}
                    limitLengthValue={450}
                    error={this.state.showError ? this.findErrorInVersion(firstElement.name, 'releaseNote') ? true : false : false}
                    errorText={this.state.showError ? this.findErrorInVersion(firstElement.name, 'releaseNote') ? 'Please enter release notes' : '' : ''}
                  />
                </div>
                <div style={{marginLeft: '1%',marginTop: '1.5%', marginBottom: '-.75%', fontWeight: 'bolder'}}>ATTACHMENT</div>           
                <div className="d-flex">
                <div className="flex-grow-1" style={{height: '40px', paddingRight: '20px', paddingLeft: '20px', border: this.findErrorInVersion(firstElement.name, 'fileUpload') && this.state.showError ? "2px solid  #EFF3F6" : "2px solid #EFF3F6", borderRadius: '12px', margin: '10px 10px 0px 10px' }}>
                <DragDrop 
                fileUpdate={(base64Data, file)=>{
                  console.log( base64Data,file)
                  this.setState({
                    fileUploadVersion: {
                      ...this.state.fileUploadVersion,
                      [this.state.selectedVersion]: {
                        data: base64Data,
                        fileName: file.name
                      }
                    },
                    versionUpdate: {
                      ...this.state.versionUpdate,
                      [this.state.selectedVersion]: this.state.versionUpdate[this.state.selectedVersion] || ''
                    }
                  })
                }}
                fileName = {this.renderFileName(firstElement.name)}
                />
                </div>
                <div className="ml-auto" style={{height: '40px', width: '40px',padding: '8px 8px',maxWidth: '50px',backgroundColor: "#EFF3F6", paddingRight: '20px', paddingLeft: '20px', border: this.findErrorInVersion(firstElement.name, 'fileUpload') && this.state.showError ? "2px solid #EFF3F6" : "2px solid #EFF3F6", borderRadius: '12px', margin: '10px 10px 0px 10px' }}>   
                <DragDropClick 
                fileUpdate={(base64Data, file)=>{               
                  this.setState({
                    fileUploadVersion: {
                      ...this.state.fileUploadVersion,
                      [this.state.selectedVersion]: {
                        data: base64Data,
                        fileName: file.name
                      }
                    },
                    versionUpdate: {
                      ...this.state.versionUpdate,
                      [this.state.selectedVersion]: this.state.versionUpdate[this.state.selectedVersion] || ''
                    }
                  })
                }}
                fileName = {this.renderFileName(firstElement.name)}
                />               
                </div>   
                </div>    
                <div style={{marginLeft: '20px',width: '100%', marginTop: '-30px'}}>
                   { this.renderFileName(firstElement.name)!=='' ?<div  style={{ width: '100%' }}>Uploaded File: {this.renderFileName(firstElement.name)}</div> : <div  style={{ width: '100%' }}>Drag and Drop or Attach files</div>}
                  </div>
                {/* {this.findErrorInVersion(firstElement.name, 'fileUpload') && this.state.showError ? <span className="error text-danger" style={{ fontSize: '.75rem', marginLeft: '20px' }}>  Please upload pdf file having maximum size of 5MB.</span> : null}      */}
                {this.findErrorInVersion(firstElement.name, 'fileUpload') && this.state.showError ? <div className="error text-danger" style={{ fontSize: '.75rem', marginLeft: '20px',width: '100%',marginTop: '10px' }}>  Please upload pdf file having maximum size of 5MB.</div> : null}               
              </div> : null}
          </div>
        </React.Fragment>
      )
    })
    return element;
  }

  renderFileName = (name) => {
    let fileName = '';
    try {
      if (this.state.fileUploadVersion[name].fileName.length <= 50) {
        fileName = this.state.fileUploadVersion[name].fileName
      } else {
        fileName = `...${this.state.fileUploadVersion[name].fileName.slice(-30)}`
      }
    } catch (err) {
      fileName = ''
    }
    return fileName
  }

  //name is the string field which we use to find error in like error in WE.OKAS or Cloud Studio
  //errorIn is the string which defines the error in type of field. Like error in release notes or error in attachement. 
  findErrorInVersion = (name, errorIn) => {
    let hasVersion = _.indexOf(Object.keys(this.state.versionUpdate), name);
    if (hasVersion !== -1) {
      if (errorIn === 'fileUpload') {
        return this.state.fileUploadVersion[name].data === ''
      } else if (errorIn === 'section') {
        if (!(this.state.versionUpdate[name] !== '') || !(this.state.fileUploadVersion[name].data !== '')) {
          return true
        } else {
          return false
        }
      } else if (errorIn === 'releaseNote') {
        return this.state.versionUpdate[name] === ''
      }
    } else {
      return false
    }
  }
  render() {
    return (
      <React.Fragment>
        <SnackBar open={this.state.snackbarActive} handleSnackbarClose={()=>{    this.setState({
      snackbarActive: false
    })}} message={this.state.snackbarMessage}/>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-2"  style={{ color: '#888888', fontSize: '30px',marginBottom: '30px'}}>INTERNAL VERSION UPDATE</h3>
          <div className="col-12 mx-0 px-0">
            {this.renderVersionSection()}
          </div>
          <div className="float-right" style={{ marginTop: '30px', marginBottom: '30px' }}>
            <div className="btn btn-new-grey" onClick={this.closeModal} style={{ marginRight: '15px' }}>Cancel</div>
            <div className="btn btn-new-green" onClick={() => { this.updateVersionIntial() }} >Update</div>
          </div>
        </Modal>
        {this.ActivateCompleteInternalVersionModal()}
        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalSuccess}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Internal version updated successfully</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={this.closeModalSuccess}>
              Close
                            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
